import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';
import { dataLocaleState } from './atoms.js';

function useLocale() {
    var i18n = useTranslation("refront-components").i18n;
    var _a = useRecoilState(dataLocaleState), dataLocale = _a[0], setDataLocale = _a[1];
    return {
        dataLocale: dataLocale.locale,
        uiLocale: i18n.language,
        setDataLocale: setDataLocale
    };
}

export { useLocale };
//# sourceMappingURL=hooks.js.map
